import io from "socket.io-client";
import { setRoomId, setParticipants, setSocketId, setHostLeave } from "../store/actions";
import store from "../store/store";
import * as webRTCHandler from "./webRTCHandler";
import { appendNewMessageToChatHistory } from "./directMessages";
import {environment} from "../environment/environment"
import { completeInterview2 } from "./api";


// const SERVER = "https://video-meeting-backend2022.herokuapp.com/";

let socket = null;

export const connectWithSocketIOServer = () => {
  socket = io(environment.SERVER);

  socket.on("connect", () => {
    console.log("successfully connected with socket io server");
    // console.log(socket.id);
    store.dispatch(setSocketId(socket.id));
  });

  socket.on("room-id", (data) => {
    const { roomId } = data;
    store.dispatch(setRoomId(roomId));
  });

  socket.on("room-update", (data) => {
    const { connectedUsers } = data;
    store.dispatch(setParticipants(connectedUsers));
  });

  socket.on("host-leave", (data) => {
    // const { connectedUsers } = data;
    // store.dispatch(setParticipants(connectedUsers));
    // store.dispatch(setHostLeave(true));
    console.log("Host is leaving the room event come from socket", data)
  });

  socket.on("conn-prepare", (data) => {
    const { connUserSocketId } = data;

    webRTCHandler.prepareNewPeerConnection(connUserSocketId, false);

    // inform the user which just join the room that we have prepared for incoming connection
    socket.emit("conn-init", { connUserSocketId: connUserSocketId });
  });

  socket.on("conn-signal", (data) => {
    webRTCHandler.handleSignalingData(data);
  });

  socket.on("conn-init", (data) => {
    const { connUserSocketId } = data;
    webRTCHandler.prepareNewPeerConnection(connUserSocketId, true);
  });

  socket.on("user-disconnected", (data) => {
    console.log("user is disconnected fron the room",data);
    webRTCHandler.removePeerConnection(data);
    onDisconnect(data)
  });

  socket.on("direct-message", (data) => {
    appendNewMessageToChatHistory(data);
  });
};

export const createNewRoom = (identity, onlyAudio, hostId, userId) => {
  // emit an event to server that we would like to create new room
  const data = {
    identity,
    onlyAudio,
    hostId,
    userId
  };

  socket.emit("create-new-room", data);
};

export const joinRoom = (identity, roomId, onlyAudio,userId) => {
  //emit an event to server that we would to join a room
  const data = {
    roomId,
    identity,
    onlyAudio,
    userId
  };

  socket.emit("join-room", data);
};

export const signalPeerData = (data) => {
  socket.emit("conn-signal", data);
};

export const sendDirectMessage = (data) => {
  socket.emit("direct-message", data);
};

const onDisconnect =(data)=>{
  
  const obj = {
    roomId: data?.user?.roomId,
    userId: data?.user?.userId
  }
  
  console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", obj);

  completeInterview2(obj)

}